/*
*地图监控选择地址
*/
const state = {
    addressInfo:{},//选择的地址信息
};
const actions = {
    // 赋值要修改的地址下标
    setDistaptchSelectAddress({commit},value){
        commit('SET_DISPATCH_SELECT_ADDRESS',value);
    },
}
const mutations = {
    SET_DISPATCH_SELECT_ADDRESS(state,value){
        state.addressInfo = value;
    },
}

export default{
	state,
	actions,
	mutations
}